"use client";
import React from "react";
import { HeaderTextGalleryButtonSection } from "@/src/api/fetchHomeSections/types";
import { useFindSection } from "@/src/hooks/useFindSection";
import { HomeSectionProps } from "@/src/types/home-section-props";
import {
  AnimatedGallery,
  AnimatedText,
  ContactUs,
  HomeSectionContainer,
} from "@/src/components";
import { useParseLinks } from "@/src/hooks/useParseLinks";
import ReusableButtons from "@/src/components/ReusableButtons/ReusableButtons";
import useModal from "@/src/hooks/useModal";

const WeMeasure: React.FC<HomeSectionProps> = ({ data }) => {
  const foundSection = useFindSection(data, "header+text+gallery+button");
  const section = foundSection as HeaderTextGalleryButtonSection | undefined;
  const { parseLinks } = useParseLinks();
  const {
    isOpen: isContactModalOpen,
    openPopup: openContactModal,
    closePopup: closeContactModal,
  } = useModal();
  
  if (!section) return null;

  return (
    <HomeSectionContainer>
      <AnimatedText direction="left">
        <p
          className="home-section-title"
          dangerouslySetInnerHTML={{ __html: section.header }}
        />
        <p className="home-section-text">
          {parseLinks(section.subtitle || "")}
        </p>
        {section.buttons && (
          <ReusableButtons buttons={section.buttons} onContactClick={openContactModal} />
        )}
      </AnimatedText>
      <AnimatedGallery images={section.gallery} direction="bottom" />
      <ContactUs isOpen={isContactModalOpen} onClose={closeContactModal} />
    </HomeSectionContainer>
  );
};

export default WeMeasure;
